import Grid from '@mui/material/Grid'
import { ProjectCard } from '@/components/projects/card/ProjectCard'
import { Project } from '@/interfaces/projects'

interface ProjectsGridProps {
  projects: Project[]
  columns?: number
}

const ProjectsGrid = ({ projects, columns = 3 }: ProjectsGridProps): React.ReactElement => {
  const itemColumnSize = 4
  const gridColumns: any = {
    xs: itemColumnSize * 1,
    sm: itemColumnSize * 3,
    md: columns * itemColumnSize
  }

  return (
    <Grid container spacing={5} columns={gridColumns}>
      {projects &&
        projects.map((project: Project, index: number) => (
          <Grid item xs={itemColumnSize} key={`project-${project.projectIdExt}`}>
            <ProjectCard project={project} priority={index < 6} />
          </Grid>
        ))}
    </Grid>
  )
}

export default ProjectsGrid
